import { render, staticRenderFns } from "./regionCompare.vue?vue&type=template&id=2eb38b9e"
import script from "./regionCompare.vue?vue&type=script&lang=js"
export * from "./regionCompare.vue?vue&type=script&lang=js"
import style0 from "./regionCompare.vue?vue&type=style&index=0&id=2eb38b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports